export const formatDurationMinutes = (minutes?: number | null): string | null => {
  if (minutes == null || Number.isNaN(minutes)) {
    return null
  }

  const total = Math.max(0, Math.round(minutes))

  if (total < 60) {
    return `${total}m`
  }

  const hours = Math.floor(total / 60)
  const remainingMinutes = total % 60

  if (hours < 24) {
    return remainingMinutes === 0 ? `${hours}h` : `${hours}h ${remainingMinutes}m`
  }

  const days = Math.floor(hours / 24)
  const remainingHours = hours % 24

  return remainingHours === 0 ? `${days}d` : `${days}d ${remainingHours}h`
}
